<template>
    <div class="chartBox">
        <div class="bg-color-black">
            <div class="d-flex pt-2 pl-2 flexStart">
                <div style="color:#5cd9e8;margin-right: 10px;">
                    <i class="el-icon-s-data"></i>
                </div>
                <div class="flexStart">
                    <span class="fs-xl text mx-2" style="margin-right: 10px;">
                        已缴费人员填报情况
                    </span>
                    <dv-decoration-1 style="width:30%;height:1rem;" />
                </div>
            </div>
            <div class="d-flex jc-center body-box feeContainer flexCloumnCenter"
                style="height:calc(100% - 30px);margin-top: 10px;">
                <table class="dtable scoredt">
                    <thead>
                        <tr>
                            <td>学制</td>
                            <td>招生计划</td>
                            <td>实招人数</td>
                            <td>平均分</td>
                            <td>最高分</td>
                            <td>最低分</td>
                            <td>已确认</td>
                            <td>已录取</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, idx) in DataList" @click="showScore(item)" :key="idx" >
                            <td>{{ item.title }}</td>
                            <td>{{ item.plan }}</td>
                            <td>{{ item.score.zscount }}</td>
                            <td>{{ item.score.avg }}</td>
                            <td>{{ item.score.max }}</td>
                            <td>{{ item.score.min }}</td>
                            <td>{{ item.queren ? item.queren : 0 }}</td>
                            <td>{{ item.fenban ? item.fenban : 0 }}</td>
                        </tr>
                    </tbody>
                </table>

            </div>
        </div>
        <!-- <xibuData :zsdata="config" v-if="datashow"></xibuData> -->
    </div>
</template>

<script>
// import xibuData from "./majorscore.vue"
export default {
    components: {
        // xibuData
    },
    data() {
        return {
            // datashow: false,
            DataList: [],
            config: []
        };
    },


    mounted() { this.getList() },
    methods: {
        getList() {
            this.$http.post("/api/xuezhi_score_zstongji").then(res => {
                if (this.$store.state.pmid == 7 || this.$store.state.pmid == 12) {//玄武要其他的人数
                    this.$http.post("/api/get_xuezhi_stucount").then(res2 => {
                        for (let xz of res.data) {

                            for (let jf of res2.data.jiaofei) {
                                if (xz.title == jf.item_desc) {

                                    xz.jiaofei = jf.stu_count;
                                    break
                                }
                            }
                            for (let jf of res2.data.queren) {
                                if (xz.title == jf.item_desc) {
                                    xz.queren = jf.stu_count;
                                    break
                                }
                            }
                            for (let jf of res2.data.fenban) {
                                if (xz.title == jf.item_desc) {
                                    xz.fenban = jf.stu_count;
                                    break
                                }
                            }
                        }

                        this.DataList = res.data
                        this.$http.post("/api/get_zhuanye_stucount").then(res3 => {
                            for (let xz of res.data) {
                                for (let zy of xz.majors) {
                                    for (let jf of res3.data.jiaofei) {
                                        if (zy.title == jf.major_name) {
                                            zy.jiaofei = jf.stu_count;
                                            break
                                        }
                                    }
                                    for (let jf of res3.data.queren) {
                                        if (zy.title == jf.major_name) {
                                            zy.queren = jf.stu_count;
                                            break
                                        }
                                    }
                                    for (let jf of res3.data.fenban) {
                                        if (zy.title == jf.major_name) {
                                            zy.fenban = jf.stu_count;
                                            break
                                        }
                                    }
                                }



                            }
                            this.DataList = res.data
                        })

                    })
                } else {
                    this.DataList = res.data
                }

            })
        },
        showScore(e) {
            // this.config = e;
            // this.datashow = true
        }
    },
};
</script>
<style lang="less" type="text/less">
.feeContainer {
    .dv-capsule-chart {
        padding-bottom: 0;

        .capsule-container {
            flex: 0 0 60%;
        }
    }

    .unit-label {
        div {
            color: #0d1224;

        }
    }

    .unit-text {
        color: #0d1224;
        //color: pink;
    }
}
</style>
<style scope lang="less" type="text/less">
.chartBox {
    width: 100%;
    height: 100%;
}

.scoredt tr td {
    border: 1px solid #ccc;
}

.scoredt td {
    border: 1px solid #ccc;
}
</style>
